'use strict';

function emptyFunction() {}

export default emptyFunction;




/** WEBPACK FOOTER **
 ** ./src/utils/empty-function.js
 **/